"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isHevyChatUpdatePush = exports.isMessage = void 0;
const isMessage = (message) => {
    return (!!message &&
        !!message.conversation_id &&
        !!message.sender_user_id &&
        !!message.type);
};
exports.isMessage = isMessage;
const isHevyChatUpdatePush = (message) => {
    return !!message && typeof message.type === 'string';
};
exports.isHevyChatUpdatePush = isHevyChatUpdatePush;
